export default {
  driverList: [],
  driverInfo: null,
  currentFilter: null,
  currentSort: null,
  currentPage: null
}
